// extracted by mini-css-extract-plugin
export default {"page":"feel-in-crowd_page__eFJ7e"};